import { noneProfile } from "assets";
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel";

export default function CoverUserProfile({ userCoverPictures }: { userCoverPictures: any }) {
  return (
    <div className="relative flex justify-center rounded-3xl w-full h-[200px] sm:h-[300px] md:h-[400px]">
      <Carousel className="h-full border-none">
        <CarouselContent className="w-full h-[200px] sm:h-[300px] md:h-[400px] border-none rounded-b-3xl aspect-[16/9]">
          {userCoverPictures.length > 0 ? (
            <>
              {userCoverPictures.map((coverPicture: any, coverIndex: number) => {
                return (
                  <CarouselItem key={coverIndex} className="rounded-3xl cursor-grab">
                    <img src={coverPicture?.picture} className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-b-3xl aspect-[9/16]" alt="cover" />
                  </CarouselItem>
                );
              })}
            </>
          ) : (
            <CarouselItem className="rounded-3xl">
              <img src={noneProfile} className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-b-3xl aspect-[9/16]" alt="cover" />
            </CarouselItem>
          )}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
